module.exports = __webpack_public_path__ + "img/quality-control--xxl.909e1290.jpg";